module.exports = __webpack_public_path__ + "static/img/fx_lc.4f6a576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx_lc.png
// module id = cJFA
// module chunks = 1